export default {
  preview: {
    label: 'Esikatselu',
    tooltip: 'Esikatsele verkkotilaussivua uudessa välilehdessä.',
  },
  buttons: {
    visit_online_store: 'Verkkokauppa',
  },
  toasts: {
    failed_to_launch_orders_portal_app: 'Tilausportaalin käynnistäminen epäonnistui',
  },
};
